var paragraph_default = {
  "fontElementMap": "-WJQL",
  "elementSpacing": "moiMM",
  "text": "_4SgAv moiMM",
  "child": "_7yp6w"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
